module.exports = "./img/desktop_logo.80b880f.png";